import React from 'react';
import './TypeController.scss';

const TypeController = ({ showMovies, showTVs, showActive }) => {
  return (
    <div className="switch-button">
      <button
        className={`switch-button-case ${showActive === 'movie' ? 'active-btn' : ''}`}
        onClick={showMovies}>
        Movies
      </button>
      <button
        className={`switch-button-case ${showActive === 'tv' ? 'active-btn' : ''}`}
        onClick={showTVs}>
        TV
      </button>
    </div>
  );
};

export default TypeController;
